import React, { useEffect, useState } from 'react';
import "./Notifications.scss"
import ModalComponent from '../../UI/ModalComponent/ModalComponent';
import NotificationsList from '../NotificationsList/NotificationsList';

import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setCountAction } from '../../../store/notificationsReducer';

const Notifications = () => {
	const dispatch = useDispatch()
	const unreadCount = useSelector(state => state.notifications.unreadCount)
	const clinic = useSelector(state => state.recordsTable.clinic)
	const currentUser = useSelector(state => state.currentUser.currentUser)
	const [ counter, setCounter ] = useState(0);

	useEffect(() => {
		if(!unreadCount && unreadCount !== 0){

		} else {
			setCounter(unreadCount)
		}
	}, [unreadCount])

	useEffect(() => {
		if(clinic && currentUser) fetchUserUnreadNotificationsCount(clinic, currentUser.id);
		let timerId = setInterval(() => {
			initFetchUpdate(clinic, currentUser.id)
		}, 60 * 1000);
		return ()=>{clearInterval(timerId);};
	}, [clinic, currentUser])

	const initFetchUpdate = (clinicID, userID) => {
		if(clinicID && userID) fetchUserUnreadNotificationsCount(clinicID, userID)
	}

	const [fetchUserUnreadNotificationsCount] = useFetching(async (clinicId, userId) => {
		const response = await PostService.getUserUnreadNotificationsCount(clinicId, userId)
		if (response.data.success && response.data.result !== false) {
			dispatch(setCountAction(Number(response.data.result)))
		}
	})

	return (
		<div className="notifications">
			<div className="notifications__button-holder">
				<ModalComponent
					sidebar={true}
					button={<div className="notifications__button"></div>}>
					<NotificationsList/>
				</ModalComponent>
				{counter > 0 &&
					<span className="notifications__button-counter">{counter < 100 ? counter : '99+'}</span>
				}
			</div>
		</div>
	);
};

export default Notifications;
